import React from "react";
import FileInStageArea from "./FileInStageArea";

import "./stage-area-of-files.styles.css";

const StageAreaOfFiles = ({ filesInStage, ContactId, setFilesInStage }) => {
  return (
    <ul className="files-stage-area">
      {filesInStage
        .filter((fileToFilter) => {
          return (
            fileToFilter.idAtendimento === ContactId.idatendimento ||
            parseInt(fileToFilter.idAtendimento) ===
              parseInt(ContactId.idatendimento)
          );
        })
        .map((fileData, index) => {
          return (
            <FileInStageArea
              key={`file-in-stage-area--${index}`}
              filesInStage={filesInStage}
              setFilesInStage={setFilesInStage}
              fileData={fileData}
              index={index}
            />
          );
        })}
    </ul>
  );
};

export default StageAreaOfFiles;
